module.exports = __webpack_public_path__ + "static/media/008-like.b64d28c0.svg";